/* eslint-disable no-bitwise */
export function stringToColor(string) {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';
  let totalBrightness = 0;

  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
    // Calculating weighted brightness of the color
    if (i === 0) {
      // Red
      totalBrightness += value * 0.299;
    } else if (i === 1) {
      // Green
      totalBrightness += value * 0.587;
    } else {
      // Blue
      totalBrightness += value * 0.114;
    }
  }

  // Define minimum acceptable brightness (scale 0-255, adjust as needed)
  const minBrightness = 100;

  // If color is too light, adjust it to have at least the minimum brightness
  if (totalBrightness > 255 - minBrightness) {
    color = '#';
    for (let i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      const darkenedValue = Math.floor(value * (minBrightness / totalBrightness));
      color += `00${darkenedValue.toString(16)}`.slice(-2);
    }
  }

  return color;
}

export function stringAvatar(name) {
  if (!name) return {};
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: `${name.split(' ')[0]?.[0] ?? ''}${name.split(' ')[1]?.[0] ?? ''}`?.toUpperCase() ?? null,
  };
}
